module.exports = __webpack_public_path__ + "img/img151_3.96074e3e.png";